/**
 * @file 飞桨硬件生态共创计划 首页
 * @author duzhengqiang
 */
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'location-origin';
import ReactDOM from 'react-dom';
import HardwareCoCreation from './HardwareCoCreation';
import './style.less';

 

 
ReactDOM.render(<HardwareCoCreation />, document.getElementById('root'));